<template>
  <div class="form-group discount-selector" v-if="discounts && discounts.length">
    <multiselect v-model="selectedDiscount" :options="discounts" v-if="needsSearch" :custom-label="makeDesc" track-by="id" :placeholder="_('Discount')" :multiple="false" :searchable="true" v-on:select="discountSelected" v-on:remove="discountRemoved">
      <template slot="noOptions">-</template>
      <template #noResult>{{ _('No discounts') }}</template>
      <template slot="option" slot-scope="props">
        <li><i v-if="props.option.billingcustomer" class="fa fa-fw fa-building-o"></i> {{ makeDesc(props.option) }}</li>
      </template>
    </multiselect>
    <select class="form-control" v-else v-model="selectedDiscount" v-on:change="discountChanged">
      <option value="null">{{ _('Select a discount') }}</option>
      <option v-for="discount in discounts" :value="discount"><span v-if="discount.billingcustomer">* </span>{{ makeDesc(discount) }}</option>
    </select>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import { mapGetters } from 'vuex'
import errors from '~/lib/errors'

export default {
  data () {
    return {
      selectedDiscount: null,
      discounts: []
    }
  },
  mixins: [ errors ],
  props: ['item', 'allItems', 'billingCustomer', 'locale', 'shopId', 'baseDomain', 'settings'],
  computed: {
    ...mapGetters(['apiKey', 'activeBasket']),
    needsSearch () {
      if (this.discounts && this.discounts.length > 5) {
        return true
      }
      return false
    }
  },
  methods: {
    makeDesc (discount) {
      let s = discount.code
      s += ' ('
      s += '-' + discount.amount
      if (parseInt(discount.unit)) {
        if (this.item) {
          s += ' ' + this.item.currency
        } else if (this.settings) {
          s += ' ' + this.settings.currency
        }
      } else {
        s += ' %'
      }
      s += ')'
      return s
    },
    discountChanged () {
      if (this.selectedDiscount == 'null') {
        return this.discountRemoved()
      }
      this.discountSelected(this.selectedDiscount)
    },
    discountSelected (selectedOption) {
      let data = {
        shopId: this.shopId,
        locale: this.locale,
        code: selectedOption.code,
        id: selectedOption.id,
      }
      if (this.item) {
        data.item = this.item
      } else if (this.selectedDiscount) {
        this.discountRemoved()
      }
      try {
        this.$store.dispatch('addToBasket', data)
      } catch(err) {
        this.showAddedToBasketError(err)
        return
      }
    },
    discountRemoved () {
      let item = false
      if (!this.item) {
        if (!this.selectedDiscount) {
          return
        }
        for (var i = 0; i < this.allItems.length; i++) {
          if (this.allItems[i].discount_id && !parseInt(this.allItems[i].discountlocked) && this.allItems[i].discount_id == this.selectedDiscount.id) {
            item = this.allItems[i]
            break
          }
        }
      } else {
        for (var i = 0; i < this.allItems.length; i++) {
          if (this.allItems[i].id == this.item.modifier_id && this.allItems[i].discount_id) {
            item = this.allItems[i]
            break
          }
        }
      }
      if (item) {
        this.$store.dispatch('deleteItemFromBasket', {
          id: item.id,
          item: item,
          shopId: this.shopId,
          index: this.activeBasket
        })
        // This probably does nothing
        this.$emit('deleteItemFromBasket', { item: item, shopId: this.shopId })
      }
    },
    autoSetSelectedDiscount () {
      if (!this.item) { // This is the global selector
        for (var i = 0; i < this.allItems.length; i++) {
          if (this.allItems[i].discount_id && !parseInt(this.allItems[i].discountlocked)) {
            for (var j = 0; j < this.discounts.length; j++) {
              if (this.discounts[j].id == this.allItems[i].discount_id) {
                this.selectedDiscount = this.discounts[j]
                return
              }
            }
          }
        }
      } else if (this.item.modifier_id) {
        for (var i = 0; i < this.allItems.length; i++) {
          if (this.allItems[i].id == this.item.modifier_id && this.allItems[i].discount_id) {
            for (var j = 0; j < this.discounts.length; j++) {
              if (this.discounts[j].id == this.allItems[i].discount_id) {
                this.selectedDiscount = this.discounts[j]
                return
              }
            }
          }
        }
      }
    },
    loadDiscounts () {
      return new Promise(async (resolve, reject) => {
        let response
        let itemStr = ''
        if (this.item && this.item.id) {
          itemStr = '/items/' + this.item.id
        }
        try {
          response = await axios.get(this.baseDomain + this.shopId + itemStr + '/discounts.json?common=true&apikey=' + this.apiKey)
        } catch (e) {
          reject(e)
          return
        }
        let discounts = response.data
        if (this.billingCustomer && this.billingCustomer.id) {
          try {
            if (this.item && this.item.id) {
              response = await axios.get(this.baseDomain + this.shopId + itemStr + '/discounts.json?apikey=' + this.apiKey + '&billingcustomer=' + this.billingCustomer.id)
            } else {
              response = await axios.get(this.baseDomain + this.shopId + '/billingcustomers/' + this.billingCustomer.id + '/discounts.json?apikey=' + this.apiKey)
            }
          } catch (e) {
            reject(e)
            return
          }
          this.discounts = [...response.data.map(d => { d.billingcustomer = true; return d }), ...discounts.filter(d => !response.data.map(r => r.id).includes(d.id))]
        } else {
          this.discounts = discounts
        }
        resolve(this.discounts)
      })
    },
  },
  watch: {
    item: {
      deep: true,
      handler () {
        this.autoSetSelectedDiscount()
      }
    },
    async billingCustomer () {
      await this.loadDiscounts()
      this.autoSetSelectedDiscount()
    }
  },
  async mounted () {
    await this.loadDiscounts()
    this.autoSetSelectedDiscount()
  },
  components: {
    Multiselect
  }
}
</script>